import classnames from 'classnames';
import React, { DetailedHTMLProps, HTMLAttributes } from 'react';

import { default as pluralize } from 'pluralize';
import '../styles/index.scss';
export type ChargeCountsProps = {
  counts: CMxCommonApp.ChargeCodeCounts;
} & DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>;

const DEFAULT_PROPS = {
  counts: {
    procedures: 0,
    diagnosis: 0,
    modifiers: 0
  }
};

const ChargeCounts = (props: ChargeCountsProps) => {
  const appliedProps = { ...DEFAULT_PROPS, ...props };
  const { counts, ...rest } = appliedProps;

  const hasProcedures = counts.procedures > 0;
  const hasDX = counts.diagnosis > 0;
  const hasMods = counts.modifiers > 0;

  const styleClasses = [
    'charge-counts',
    {
      'has-procedures': hasProcedures,
      'has-dx': hasDX,
      'has-mods': hasMods
    }
  ];

  const itemTypes = [hasProcedures, hasDX, hasMods].filter(item => item).length;
  const readout = [];

  if (hasProcedures) {
    readout.push(
      `${counts.procedures} ${pluralize('procedure', counts.procedures)}`
    );
  }
  if (hasDX) {
    const dxString =
      counts.diagnosis === 1
        ? `${counts.diagnosis} diagnosis`
        : `${counts.diagnosis} diagnoses`;
    readout.push(dxString);
  }
  if (hasMods) {
    const slug = readout.length === 2 ? 'and ' : '';
    readout.push(
      `${slug}${counts.modifiers} ${pluralize('modifier', counts.modifiers)}`
    );
  }
  let summary = '';

  if (readout.length === 0) {
    summary = 'No codes assigned';
  } else if (readout.length === 1) {
    summary = readout.join('');
  } else if (readout.length === 2) {
    summary = readout.join(' and ');
  } else {
    summary = readout.join(', ');
  }

  return (
    <div {...rest} className={classnames(styleClasses)}>
      {summary}
    </div>
  );
};

ChargeCounts.displayName = 'ChargeCounts';

export { ChargeCounts };
